import {
    Button,
    Modal,
    ModalActions,
    ModalContent,
    ModalContentText,
    ModalTitle,
} from '@deere/fuel-react';
import React, { useContext, useState } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { useNavigate } from 'react-router-dom';
import { LoggedInContext } from '../context/LoggedInContext';
import { WorkforceContext } from '../context/WorkforceContext';

export const WithdrawBidModal = (props) => {
    const [isWithdrawButtonClicked, setIsWithdrawButtonClicked] =
        useState(false);
    const { authState } = useOktaAuth();
    const navigate = useNavigate();
    const { makeRequest, impersonatedId } = useContext(LoggedInContext);
    const { setTriggerRefresh } = useContext(WorkforceContext);

    const withdrawHandler = () => {
        withdrawBid();
        setIsWithdrawButtonClicked(false);
    };

    const withdrawBid = async () => {
        try {
            const requestOptions = {
                method: 'POST',
                body: JSON.stringify({
                    jobNumber: props.jobNumber,
                    racf: impersonatedId
                        ? impersonatedId
                        : authState.accessToken.claims.userID,
                    id: props.bidId,
                }),
            };

            const response = await makeRequest(
                process.env.REACT_APP_API_ENDPOINT +
                    '/job/' +
                    props.jobNumber +
                    '/withdrawBidder',
                requestOptions
            );

            if (response.status === 200) {
                setTriggerRefresh((t) => !t);
                setIsWithdrawButtonClicked(false);
                props.apiResponse('success');
                navigate('/my-job-bids');
            } else {
                setIsWithdrawButtonClicked(false);
                props.apiResponse('error', response);
            }
        } catch (err) {
            setIsWithdrawButtonClicked(false);
            props.apiResponse('error', err);
        }
    };

    const openWithdrawPrompt = () => {
        setIsWithdrawButtonClicked(true);
    };

    const cancelClick = () => {
        setIsWithdrawButtonClicked(false);
    };

    return (
        <>
            <Modal
                open={isWithdrawButtonClicked}
                onClose={cancelClick}
                aria-labelledby="alert-Modal-title"
                aria-describedby="alert-Modal-description"
            >
                <ModalTitle id="alert-Modal-title">
                    Are You Sure You Want to Withdraw Your Bid?
                </ModalTitle>
                <ModalContent>
                    <ModalContentText id="alert-Modal-description">
                        By clicking Withdraw My Bid, your bid will be
                        permanently removed from this job and cannot be undone.
                    </ModalContentText>
                </ModalContent>
                <ModalActions>
                    <Button onClick={cancelClick} variant="secondary">
                        Cancel
                    </Button>
                    <Button onClick={withdrawHandler} variant="primary">
                        Withdraw My Bid
                    </Button>
                </ModalActions>
            </Modal>
            <Button variant="primary" onClick={openWithdrawPrompt}>
                Withdraw My Bid
            </Button>
        </>
    );
};
